var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFlyingColorsBenefit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.133 49.867l1.6 3.066C70 57.333 68.8 62.8 64.8 65.867L54.267 73.6S60.8 62 52.133 55.733M42.933 30.533l-3.2-.933c-4.8-1.467-10 .8-12.133 5.2l-5.733 11.733s10.266-8.4 18-1.066",
    stroke: "#0C0A0C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83.467 25.6c-.4 6.4-3.334 12.4-8.134 16.666l-25.6 22.667-.933.8c-2.267 2-5.733 2-8-.133l-7.333-6.8c-2.8-2.533-3.334-6.667-1.6-10l.266-.4L47.2 21.333c3.733-6.666 10.4-11.2 18-12.266l16.8-2.4c1.333-.134 2.667.933 2.533 2.4l-1.066 16v.533z",
    fill: "#89EC54"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.442 29.81c.86-3.124-1.436-6.48-5.127-7.496-3.692-1.017-7.382.692-8.242 3.816-.86 3.123 1.436 6.48 5.127 7.496 3.692 1.016 7.382-.692 8.242-3.816z",
    fill: "#fff",
    stroke: "#0C0A0C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.734 64.933l-.934.8-3.2 2.8c-.533.4-1.2.4-1.733 0L29.6 55.067c-.4-.4-.533-1.067-.266-1.6l2.666-4.8.267-.4 17.467 16.666z",
    fill: "#0C0A0C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8 43.2L34.267 63.467",
    stroke: "#0C0A0C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M83.467 25.067L65.334 8.933 82.8 6.667c1.067-.134 1.867.666 1.867 1.733l-1.2 16.667z",
    fill: "#0C0A0C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8 65.333l-8.533 8M32.8 70L11.467 89.333",
    stroke: "#0C0A0C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M83.845 82.234c.235-.852-.38-1.764-1.375-2.038-.994-.273-1.99.195-2.224 1.047-.235.852.381 1.765 1.375 2.038.994.274 1.99-.195 2.224-1.047zM83.683 53.856c.235-.852-.381-1.764-1.375-2.038-.994-.273-1.99.196-2.224 1.047-.235.852.38 1.765 1.375 2.038.994.274 1.99-.195 2.224-1.047zM45.528 83.615c.235-.852-.38-1.764-1.375-2.038-.994-.273-1.99.195-2.224 1.047-.235.852.381 1.765 1.375 2.038.994.274 1.99-.195 2.224-1.047zM25.956 9.765c.235-.852-.381-1.764-1.375-2.038-.994-.274-1.99.195-2.224 1.047-.235.852.38 1.765 1.375 2.038.994.274 1.99-.195 2.224-1.047zM10.858 44c.235-.851-.38-1.764-1.375-2.037-.994-.274-1.99.195-2.224 1.047-.234.852.381 1.764 1.375 2.038.994.273 1.99-.195 2.224-1.047z",
    fill: "#0C0A0C"
  })));
}

export default SvgFlyingColorsBenefit;